import { reactive, ref } from "vue";
import fetchFunction from "./fetchFunction";

const trackState = reactive({
  year: null,
  month: null,
  date: null,
  today: {
    year: null,
    month: null,
    date: null
  },
  trackContent: "dateOfAppointment",
  updateAppointmentData: [],
  clinicPeriodLastTime: {},
  department: "AestheticMedicine",
  desiredFollowUpDepartmentId: "AestheticMedicine",
  couseReason: "",
  timeRange: [],
  filterQueryStatus: {
    continuousOutpatientNum: 1,
    isAppointment: true,
    morning: true,
    afternoon: true,
    evening: true,
    courseTypeId: null
  },
  customerStoredValueData: {},
  voucherDepositData: {},
  offWorkTime: "",
  // data
  calendarData: [],
  doctorData: [],
  daysOutpatientData: [],

  selectedDoctor: [],
  showCalendarData: [],
  calendar: []
});

/** 客戶查詢 */
async function searchDetailedInformation(customer) {
  // const {name, birthday, cellPhone } = customer;

  getDepartmentFollowUpDataBySearchCondition(customer);

  // const date = `${trackState.year}-${trackState.month + 1 <= 9 ?'0':''}${trackState.month + 1}-${trackState.date <= 9 ?'0':''}${trackState.date}`;

  // let url = `${process.env.VUE_APP_API_URL}/api/MedicalRecord/GetDoctorAttendanceDataBySearchCondition?departmentId=${trackState.department}&customerName=${name}&customerBirthday=${birthday}&customerCellPhone=${cellPhone}&date=${date}&clinicPeriods=Morning&clinicPeriods=Afternoon&clinicPeriods=Evening`;

  // if (trackState.department === 'Beauty') {
  //   url = `${process.env.VUE_APP_API_URL}/api/MedicalRecord/GetDepartmentAttendanceDataBySearchCondition?departmentId=${trackState.department}&customerName=${name}&customerBirthday=${birthday}&customerCellPhone=${cellPhone}&date=${date}&clinicPeriods=Morning&clinicPeriods=Afternoon&clinicPeriods=Evening`;
  // }

  // trackState.selectedDoctor.forEach(item => {
  //   url = `${url}&doctors=${item.id}`;
  // });

  // let response = await fetch(url).then(res => res.json()).then(res => res.data);

  // detailedInformationInit(response);
}

/** 詳細到診資料 */
const detailedinformationData = ref([]);

/** 醫美部 - 取得詳細到診 */
async function getDoctorAttendanceData() {
  const date = `${trackState.year}-${trackState.month + 1 <= 9 ? "0" : ""}${trackState.month + 1}-${trackState.date <= 9 ? "0" : ""}${trackState.date}`;

  let url = `/api/MedicalRecord/GetDoctorAttendanceData?departmentId=${trackState.department}&date=${date}`;

  trackState.selectedDoctor.forEach((item) => {
    url = `${url}&doctors=${item.id}`;
  });

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  detailedInformationInit(response.data);
}

/** 取得醫師資料 */
const getDoctors = async () => {
  const url = `/api/Employee/GetDoctorByActiveStatus?active=true`;

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  if (response.statusCode >= 400) return null;

  let doctorData = response.data;

  const doctorDataLength = doctorData.length <= 4 ? doctorData.length : 4;

  for (let i = 0; i < doctorDataLength; i++) {
    doctorData[i].select = true;
  }
  trackState.doctorData = doctorData;
};

/** 取約診、候補的最新資料 */
const getUpdateAppointmentData = async (id) => {
  const token = fetchFunction.getTokenFromCookie();

  const url = `/api/Appointment/GetInitUpdateAppointmentData?id=${id}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  trackState.updateAppointmentData = response.data;
};

/** 取得/重製已選擇醫師 */
const resetSelectedDoctor = () => {
  trackState.selectedDoctor = [];

  trackState.doctorData.forEach((item) => {
    if (item.select) {
      trackState.selectedDoctor.push(item);
    }
  });
};

/** 取日班表，醫美部與美容部 */
const getDaysOutpatientData = async () => {
  const date = `${trackState.year}-${trackState.month + 1 <= 9 ? "0" : ""}${trackState.month + 1}-${trackState.date <= 9 ? "0" : ""}${trackState.date}`;

  let url = `/api/Outpatient/GetDaysOutpatientData?departmentId=${trackState.department}&date=${date}${trackState.filterQueryStatus.morning ? `&clinicPeriods=Morning` : ""}${trackState.filterQueryStatus.afternoon ? `&clinicPeriods=Afternoon` : ""}${trackState.filterQueryStatus.evening ? `&clinicPeriods=Evening` : ""}`;

  trackState.selectedDoctor.forEach((item) => {
    url = `${url}&doctors=${item.id}`;
  });

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  trackState.daysOutpatientData = response.data;

  const { daysOutpatients, customerStoredValueData, voucherDepositData } = trackState.daysOutpatientData;

  trackState.customerStoredValueData = customerStoredValueData;
  trackState.voucherDepositData = voucherDepositData;

  // 取出顯示資料最後的時間

  const timeArr = Object.keys(daysOutpatients);

  if (timeArr.length === 0) return null;

  // 時間間格
  const hourIntervals = timeArr[1].split(":")[0] - timeArr[0].split(":")[0];
  const minuteIntervals = timeArr[1].split(":")[1] - timeArr[0].split(":")[1];

  const lastData = timeArr[timeArr.length - 1].split(":");

  let time = new Date(0, 0, 0, lastData[0], lastData[1]);

  time.setHours(time.getHours() + hourIntervals);
  time.setMinutes(time.getMinutes() + minuteIntervals);

  trackState.offWorkTime = `${time.getHours()}:${time.getMinutes() <= 9 ? 0 : ""}${time.getMinutes()}`;

  // 取跨時段

  trackState.timeRange = [];

  if (trackState.department === "AestheticMedicine") {
    for (let i = 0; i < timeArr.length; i++) {
      for (let j = 0; j < trackState.selectedDoctor.length; j++) {
        if (daysOutpatients[timeArr[i]][trackState.selectedDoctor[j].id].normalAppointment) {
          if (daysOutpatients[timeArr[i]][trackState.selectedDoctor[j].id].normalAppointment.timeRange > 1) {
            let itemRange = daysOutpatients[timeArr[i]][trackState.selectedDoctor[j].id].normalAppointment.timeRange;

            for (let k = i; k < i + itemRange; k++) {
              trackState.timeRange.push({
                operatorId: daysOutpatients[timeArr[i]][trackState.selectedDoctor[j].id].normalAppointment.operatorId,
                time: timeArr[k],
                left: daysOutpatients[timeArr[i]][trackState.selectedDoctor[j].id].normalAppointment.left,
                lastTimeSlot: k + 1 === i + itemRange ? true : false
              });
            }
          }
        }
      }
    }
  }

  if (trackState.department === "Beauty") {
    for (let i = 0; i < timeArr.length; i++) {
      if (daysOutpatients[timeArr[i]].normalAppointment) {
        if (daysOutpatients[timeArr[i]].normalAppointment.timeRange > 1) {
          let itemRange = daysOutpatients[timeArr[i]].normalAppointment.timeRange;

          for (let k = i; k < i + itemRange; k++) {
            trackState.timeRange.push({
              operatorId: daysOutpatients[timeArr[i]].normalAppointment.operatorId,
              time: timeArr[k],
              left: daysOutpatients[timeArr[i]].normalAppointment.left,
              lastTimeSlot: k + 1 === i + itemRange ? true : false
            });
          }
        }
      }
    }
  }
};

/** 取今日日期 */
const getCurrentMonth = () => {
  const data = new Date();

  trackState.today = {
    month: data.getMonth() + 1,
    year: data.getFullYear(),
    date: data.getDate()
  };
  trackState.month = data.getMonth(); // 0 - 11
  trackState.year = data.getFullYear();
  trackState.date = data.getDate();
};

/** 取得早、午診最後時間 */
const getClinicPeriodLastTime = async () => {
  const url = `/api/Outpatient/GetClinicPeriodLastTime?departmentId=${trackState.department}&date=${trackState.year}-${trackState.month + 1}-${trackState.date}`;

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  trackState.clinicPeriodLastTime = response.data;
};

/** 顯示當月的總日，並把上、下個月的零碎日子加入 */
const showCalendar = (year, month) => {
  let currentMonth = getCalendar(year, month, true);

  const firstWeekLen = currentMonth[0].length;
  const lastWeekLen = currentMonth[currentMonth.length - 1].length;

  if (firstWeekLen < 7 && firstWeekLen !== 0) {
    let lastMonth = getCalendar(year, month - 1, false);

    currentMonth[0] = lastMonth[lastMonth.length - 1].concat(currentMonth[0]);
  }

  if (lastWeekLen < 7 && lastWeekLen !== 0) {
    let nextMonth = getCalendar(year, month + 1, false);
    currentMonth[currentMonth.length - 1] = currentMonth[currentMonth.length - 1].concat(nextMonth[0]);
  }

  for (let i = 0; i < currentMonth.length; i++) {
    if (currentMonth[i].length === 0) {
      currentMonth.splice(i, 1);
    }
  }

  // 不是內地，就刪除星期天
  // if (!this.china) {
  //   this.dayLength = 6;
  //   for(let i = 0; i < currentMonth.length; i++) {
  //     currentMonth[i].splice(0, 1);
  //   }
  // }

  trackState.calendar = currentMonth;
  trackState.calendarData = currentMonth;
};

/** 取得當月的總日和資料 */
const getCalendar = (year, month, j) => {
  let calendar = [];
  let week = [];
  let data = new Date(year, month + 1, 1);

  data.setHours(data.getHours() - 1); // 下個月 - 1 小時，目的是轉換成當月的最後一天

  const allDate = data.getDate(); // 取得當月總日，例: 1 月，共 31 日

  for (let i = 1; i <= allDate; i++) {
    let morning = [];
    let afternoon = [];
    let evening = [];

    if (j) {
      for (let g = 0; g < trackState.showCalendarData.length; g++) {
        if (i === trackState.showCalendarData[g].day) {
          if (trackState.showCalendarData[g].clinicPeriod === "Morning") {
            morning.push(trackState.showCalendarData[g]);
          }

          if (trackState.showCalendarData[g].clinicPeriod === "Afternoon") {
            afternoon.push(trackState.showCalendarData[g]);
          }

          if (trackState.showCalendarData[g].clinicPeriod === "Evening") {
            evening.push(trackState.showCalendarData[g]);
          }
        }
      }
    }

    let day = new Date(year, month, i).getDay(); // 星期 : 0 - 6
    if (month === 12) {
      month = 0;
      year += 1;
    }

    if (month === -1) {
      month = 11;
      year -= 1;
    }

    week.push({
      year: year,
      month: month + 1,
      date: i,
      day: day,
      isCurrentMonth: j,
      morning,
      afternoon,
      evening
    });

    if (day === 6 || i === allDate) {
      calendar.push(week);
      week = [];
    }
  }
  return calendar;
};

/** 年和月的數字切換 */
const timeSwitch = (year, month, judge) => {
  if (judge) {
    month -= 1;
  } else {
    month += 1;
  }

  if (month === 12) {
    month = 0;
    year += 1;
  }

  if (month === -1) {
    month = 11;
    year -= 1;
  }

  return { year, month };
};

/** 候補時間轉換中文 */
const clinicPeriodToCh = (name) => {
  switch (name) {
    case "Morning":
      return "早診";
    case "Afternoon":
      return "午診";
    case "Evening":
      return "晚診";
    case "AllDay":
      return "全天";
  }
};

// -- 以下跟診 --

const detailedTrackInformationData = ref(null);

/** 取得詳細跟診資料 - 依門診 - 美容部  */
async function getDepartmentFollowUpData() {
  const date = `${trackState.year}-${trackState.month + 1 <= 9 ? "0" : ""}${trackState.month + 1}-${trackState.date <= 9 ? "0" : ""}${trackState.date}`;

  let url = `/api/MedicalRecord/GetDepartmentFollowUpData?departmentId=${trackState.department}&date=${date}`;

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  detailedInformationInit(response.data);
}

/** 取得詳細跟診資料 - 依醫師 - 醫美部  */
async function getDoctorFollowUpData() {
  const date = `${trackState.year}-${trackState.month + 1 <= 9 ? "0" : ""}${trackState.month + 1}-${trackState.date <= 9 ? "0" : ""}${trackState.date}`;

  let url = `/api/MedicalRecord/GetDoctorFollowUpData?departmentId=${trackState.department}&date=${date}`;

  trackState.selectedDoctor.forEach((item) => {
    url = `${url}&doctors=${item.id}`;
  });

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const response = await fetchFunction.fetchApi(url, options);

  //console.log(response.data, date, trackState.department, url, '取得詳細跟診資料 - 依醫師 - 醫美部');

  detailedInformationInit(response.data);
}

/** 根據條件取得詳細跟診資料(門診依部門產生時用) */
async function getDepartmentFollowUpDataBySearchCondition(customer) {
  const { name, birthday, cellPhone, courseTypeId } = customer;
  const data = {
    customerName: name,
    customerBirthday: birthday,
    customerCellPhone: cellPhone,
    courseTypeId: courseTypeId
  };

  const date = `${trackState.year}-${trackState.month + 1 <= 9 ? "0" : ""}${trackState.month + 1}-${trackState.date <= 9 ? "0" : ""}${trackState.date}`;

  let url = `/api/MedicalRecord/GetDepartmentFollowUpDataBySearchCondition?departmentId=${trackState.department}&date=${date}`;

  const token = fetchFunction.getTokenFromCookie();

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    method: "GET"
  };

  const key = Object.keys(data);

  key.forEach((item) => {
    if (data[item]) {
      url += `&${item}=${data[item]}`;
    }
  });

  const response = await fetchFunction.fetchApi(url, options);

  detailedInformationInit(response.data);
}

/** 主頁跟診資料整理 */
function detailedInformationInit(response) {
  let doctorAttendanceData = response;
  const customerIdArr = [];
  const data = [];

  if (!doctorAttendanceData) return null;

  let morning = trackState.filterQueryStatus.morning ? "早診" : null;
  let afternoon = trackState.filterQueryStatus.afternoon ? "午診" : null;
  let evening = trackState.filterQueryStatus.evening ? "晚診" : null;

  doctorAttendanceData = doctorAttendanceData.filter((item) => {
    const clinicPeriodName = item.followUpMedicalRecord.clinicPeriodName;
    return clinicPeriodName === morning || clinicPeriodName === afternoon || clinicPeriodName === evening;
  });

  if (trackState.filterQueryStatus.courseTypeId) {
    doctorAttendanceData = doctorAttendanceData.filter((item) => {
      const clinicPeriodName = item.followUpMedicalRecord.courseTypeId;
      return clinicPeriodName === trackState.filterQueryStatus.courseTypeId;
    });
  }

  doctorAttendanceData.forEach((item) => {
    if (!customerIdArr.includes(item.followUpMedicalRecord.customerId)) {
      customerIdArr.push(item.followUpMedicalRecord.customerId);
      data.push({
        customer: {
          customerId: item.followUpMedicalRecord.customerId,
          beauticianNickname: item.followUpMedicalRecord.beauticianNickname,
          customerName: item.followUpMedicalRecord.customerName,
          customerBirthday: item.followUpMedicalRecord.customerBirthday,
          customerTraitColor: item.customerTraitColor.color
        },
        followUpMedicalRecord: []
      });
    }
  });

  doctorAttendanceData.forEach((itemA) => {
    const detailItem = {
      cureContent: {
        ...itemA.followUpMedicalRecord,
        sequence: itemA.sequence
      },
      voucherUsageRecords: [],
      bodyPart: [],
      beautyConsumableName: itemA.followUpMedicalRecord.beautyConsumableName,
      orderDetails: [],
      totalExpense: 0,
      medicalRecordSubcourseData: itemA.medicalRecordSubcourseData,
      medicalRecordCustomerDemands: itemA.medicalRecordCustomerDemands,
      beauticians: itemA.beauticians,
      suggestionOfToday: itemA.suggestionOfToday,
      doctorSigned: itemA.followUpMedicalRecord.doctorSigned,
      needToSignConsent: itemA.needToSignConsent,
      needToSignPhotoConsent: itemA.needToSignPhotoConsent,
      customerStoredValueData: itemA.customerStoredValueData,
      customerSignature: itemA.customerSignature,
      couponUsageRecords: itemA.couponUsageRecords,
      prizeData: itemA.prizeData
    };

    // 麻藥費用整理
    // 不上麻不用顯示
    // 改不上麻
    if (itemA.followUpMedicalRecord.anesthesiaSituation === "CancelAnesthesia") {
      detailItem.orderDetails.push({
        chargeType: "anesthesia",
        chargeName: "麻藥費用 (改不上麻)",
        anesthesiaSituation: "CancelAnesthesia",
        price: 0,
        received: true
      });
    }

    // 上麻
    if (itemA.followUpMedicalRecord.anesthesiaSituation === "Anesthesia") {
      detailItem.orderDetails.push({
        chargeType: "anesthesia",
        chargeName: "麻藥費用",
        anesthesiaSituation: "Anesthesia",
        price:
          itemA.anestheticOrderDetail?.price === null || itemA.anestheticOrderDetail?.price === 0
            ? "免費"
            : itemA.anestheticOrderDetail?.price,
        received: itemA.anestheticOrderDetail?.received
      });
    }

    const experienceData = {
      chargeType: "cash",
      chargeName: "體驗費用",
      bodyParts: [],
      price: [],
      received: []
    };

    const depositData = {
      chargeType: "cash",
      chargeName: "押金費用",
      bodyParts: [],
      price: [],
      received: []
    };

    const onceData = {
      chargeType: "cash",
      chargeName: "單次費用",
      bodyParts: [],
      price: [],
      received: []
    };

    // 現金支付
    itemA.coursePartOrderDetails.forEach((itemB) => {
      detailItem.totalExpense += parseInt(itemB.price);

      // 體驗費用 - 初始
      if (itemB.priceType === "Experience") {
        let bodyPart = itemA.bodyPartOptions.find((itemC) => itemC.id === itemB.bodyPartId);
        if (!bodyPart) return null;
        if (itemA.followUpMedicalRecord.courseTypeId === "IV") {
          bodyPart = {
            name: bodyPart.name
          };
        }

        if (bodyPart.name === "全臉") {
          experienceData.bodyParts.unshift(bodyPart);
          experienceData.price.unshift(itemB.price);
          experienceData.received.unshift(itemB.received);
          return null;
        }

        experienceData.bodyParts.push(bodyPart);
        experienceData.price.push(itemB.price);
        experienceData.received.push(itemB.received);
        return null;
      }

      // 押金費用 - 初始
      if (itemB.priceType === "Deposit") {
        let bodyPart = itemA.bodyPartOptions.find((itemC) => itemC.id === itemB.bodyPartId);
        if (!bodyPart) return null;
        if (itemA.followUpMedicalRecord.courseTypeId === "IV") {
          bodyPart = {
            name: bodyPart.name
          };
        }
        if (bodyPart.name === "全臉") {
          depositData.bodyParts.unshift(bodyPart);
          depositData.price.unshift(itemB.price);
          depositData.received.unshift(itemB.received);
          return null;
        }

        depositData.bodyParts.push(bodyPart);
        depositData.price.push(itemB.price);
        depositData.received.push(itemB.received);
        return null;
      }

      // 單次費用 - 初始
      if (itemB.priceType === "Once") {
        if (itemB.bodyPartId === "Other") {
          onceData.bodyParts.push({
            id: itemB.bodyPartId,
            name: itemB.otherPartName
          });
          onceData.price.push(itemB.price);
          onceData.received.push(itemB.received);
          return null;
        }
        let bodyPart = itemA.bodyPartOptions.find((itemC) => itemC.id === itemB.bodyPartId);
        if (!bodyPart) return null;
        if (itemA.followUpMedicalRecord.courseTypeId === "IV") {
          bodyPart = {
            name: bodyPart.name
          };
        }

        if (bodyPart.name === "全臉") {
          onceData.bodyParts.unshift(bodyPart);
          onceData.price.unshift(itemB.price);
          onceData.received.unshift(itemB.received);
          return null;
        }

        onceData.bodyParts.push(bodyPart);
        onceData.price.push(itemB.price);
        onceData.received.push(itemB.received);
        return null;
      }
    });

    if (experienceData.bodyParts.length !== 0) {
      detailItem.orderDetails.push(experienceData);
    }

    if (depositData.bodyParts.length !== 0) {
      detailItem.orderDetails.push(depositData);
    }

    if (onceData.bodyParts.length !== 0) {
      detailItem.orderDetails.push(onceData);
    }

    // detailItem.bodyPart 資料整理
    detailItem.bodyPart = itemA.bodyPartOptions.map((item) => {
      const bodyPartItem = itemA.bodyParts.find((t) => item.id === t.bodyPartId);

      if (bodyPartItem) {
        return {
          name: item.name,
          ...bodyPartItem
          // itemA
        };
      }
    });

    // detailItem.bodyPart = itemA.bodyParts.map(item1 => {
    //   const bodyPartItem = itemA.bodyPartOptions.find(item2 => item2.id === item1.bodyPartId);

    //   return {
    //     name: bodyPartItem.name,
    //     ...item1
    //   }
    // });

    const allCoupons = [
      ...itemA.voucherUsageRecords,
      ...itemA.couponUsageRecords.map((item) => ({
        ...item,
        coursePartId: item.bodyPartId
      }))
      // ...itemA.oweVoucherSituationData
    ];

    // 療程卷號資料帶入預設位置 - 重複 id 中取唯一出來
    const uniqueId = allCoupons.filter((item, index, self) => {
      return index === self.findIndex((t) => t.coursePartId === item.coursePartId);
    });

    detailItem.voucherUsageRecords = uniqueId.map((item) => {
      if (itemA.followUpMedicalRecord.courseTypeName === "點滴") {
        return {
          bodyPartName: "IV",
          bodyPartId: item.coursePartId,
          voucherId: []
        };
      }

      let bodyPartName = itemA.bodyPartOptions.find((itemB) => itemB.id === item.coursePartId);

      return {
        bodyPartName: bodyPartName ? bodyPartName.name : null,
        bodyPartId: item.coursePartId,
        voucherId: []
      };
    });

    // 以 bodyPartId，整理欠卷
    // itemA.oweVoucherSituationData.forEach(item1 => {

    //   detailItem.voucherOrderDetails.forEach(item2 => {

    //     if (item2.bodyPartId === item1.bodyPartId) {
    //       item2.voucherId.push('oweVoucher');

    //       return null;
    //     }
    //   })
    // })

    // 以 bodyPartId，整理療程卷號
    // itemA.voucherOrderDetails.forEach(item1 => {

    //   detailItem.voucherOrderDetails.forEach(item2 => {

    //     if (item2.bodyPartId === item1.bodyPartId) {
    //       item2.voucherId.push(item1.voucherId);

    //       return null;
    //     }
    //   })
    // })

    // 以 coursePartId，整理療程卷號
    itemA.voucherUsageRecords.forEach((item1) => {
      detailItem.voucherUsageRecords.forEach((item2) => {
        if (item2.bodyPartId === item1.coursePartId) {
          item2.voucherId.push(item1.voucherId);

          return null;
        }
      });
    });
    // 以 bodyPartId，整理活動卷號
    detailItem.couponUsageRecords = allCoupons
      .map((item) => {
        let activityName = itemA.prizeData.find((activityItem) => activityItem.Id === item.prizeId);
        // console.log(activityName)
        if (item.prizeId) {
          return {
            bodyPartId: item.bodyPartId,
            activityName: activityName?.activityName,
            couponNumber: item.couponNumber,
            prizeLevel: activityName?.prizeLevel
          };
        }
      })
      .filter((item) => item !== undefined);

    // 以 bodyPartId，整理活動卷號
    // itemA.couponOrderDetails.forEach(item1 => {

    //   let couponNumber = item1.couponNumber.toString().padStart(3, 0);

    //   let volumeNumber = `${item1.activityVoucherId}${couponNumber}`;

    //   detailItem.voucherOrderDetails.forEach(item2 => {

    //     if (item2.bodyPartId === item1.bodyPartId) {
    //       item2.voucherId.push(volumeNumber);
    //     }
    //   })
    // })

    // 預設醫師資料位置，並帶入 detailItem
    data.forEach((itemB) => {
      if (itemB.customer.customerId === itemA.followUpMedicalRecord.customerId) {
        if (itemB.followUpMedicalRecord.length === 0) {
          itemB.followUpMedicalRecord.push({
            operatorName: itemA.followUpMedicalRecord.operatorName,
            operatorId: itemA.followUpMedicalRecord.operatorId,
            detail: [detailItem]
          });

          return null;
        }

        const judge = itemB.followUpMedicalRecord.some(
          (itemC) => itemC.operatorId === itemA.followUpMedicalRecord.operatorId
        );

        if (!judge) {
          itemB.followUpMedicalRecord.push({
            operatorName: itemA.followUpMedicalRecord.operatorName,
            operatorId: itemA.followUpMedicalRecord.operatorId,
            detail: [detailItem]
          });
        } else {
          itemB.followUpMedicalRecord.forEach((itemD) => {
            if (itemD.operatorId === itemA.followUpMedicalRecord.operatorId) {
              itemD.detail.push(detailItem);
            }
          });
        }
      }
    });
  });

  // 資料排序

  // 資料層排序
  data.forEach((itemA) => {
    // 客戶層
    itemA.followUpMedicalRecord.forEach((itemB) => {
      // 醫生層
      let arrive = [];
      let hasLeft = [];
      itemB.detail.forEach((itemC) => {
        // 資料層
        if (itemC.cureContent.arrivedTime && !itemC.cureContent.leftTime) {
          arrive.push(itemC);
        }

        if (itemC.cureContent.arrivedTime && itemC.cureContent.leftTime) {
          hasLeft.push(itemC);
        }
      });

      arrive.sort((a, b) => {
        const splitA = a.cureContent.arrivedTime.split("T");
        const splitB = b.cureContent.arrivedTime.split("T");
        let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
        let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

        if (timeA > timeB) {
          return -1;
        }

        if (timeA < timeB) {
          return 1;
        }

        if (timeA === timeB) {
          return 0;
        }
      });

      hasLeft.sort((a, b) => {
        const splitA = a.cureContent.arrivedTime.split("T");
        const splitB = b.cureContent.arrivedTime.split("T");
        let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
        let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

        if (timeA > timeB) {
          return 1;
        }

        if (timeA < timeB) {
          return -1;
        }

        if (timeA === timeB) {
          return 0;
        }
      });

      itemB.detail = arrive.concat(hasLeft);
    });
  });

  // console.log(itemB.detail);

  // 醫生層排序
  data.forEach((itemA) => {
    // 客戶層
    let arrive = [];
    let hasLeft = [];
    itemA.followUpMedicalRecord.forEach((itemB) => {
      // 醫生層

      if (itemB.detail[0].cureContent.arrivedTime && !itemB.detail[0].cureContent.leftTime) {
        arrive.push(itemB);
      }

      if (itemB.detail[0].cureContent.arrivedTime && itemB.detail[0].cureContent.leftTime) {
        hasLeft.push(itemB);
      }
    });

    arrive.sort((a, b) => {
      const splitA = a.detail[0].cureContent.arrivedTime.split("T");
      const splitB = b.detail[0].cureContent.arrivedTime.split("T");
      let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
      let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

      if (timeA > timeB) {
        return -1;
      }

      if (timeA < timeB) {
        return 1;
      }

      if (timeA === timeB) {
        return 0;
      }
    });

    hasLeft.sort((a, b) => {
      const splitA = a.detail[0].cureContent.arrivedTime.split("T");
      const splitB = b.detail[0].cureContent.arrivedTime.split("T");
      let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
      let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

      if (timeA > timeB) {
        return 1;
      }

      if (timeA < timeB) {
        return -1;
      }

      if (timeA === timeB) {
        return 0;
      }
    });

    itemA.followUpMedicalRecord = arrive.concat(hasLeft);
  });

  // 客戶層排序
  let arrive = [];
  let hasLeft = [];

  data.forEach((itemA) => {
    // 客戶層
    if (
      itemA.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime &&
      !itemA.followUpMedicalRecord[0].detail[0].cureContent.leftTime
    ) {
      arrive.push(itemA);
    }

    if (
      itemA.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime &&
      itemA.followUpMedicalRecord[0].detail[0].cureContent.leftTime
    ) {
      hasLeft.push(itemA);
    }
  });

  arrive.sort((a, b) => {
    const splitA = a.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime.split("T");
    const splitB = b.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime.split("T");
    let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
    let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

    if (timeA > timeB) {
      return -1;
    }

    if (timeA < timeB) {
      return 1;
    }

    if (timeA === timeB) {
      return 0;
    }
  });

  hasLeft.sort((a, b) => {
    const splitA = a.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime.split("T");
    const splitB = b.followUpMedicalRecord[0].detail[0].cureContent.arrivedTime.split("T");
    let timeA = new Date(`${splitA[0]} ${splitA[1]}`).getTime();
    let timeB = new Date(`${splitB[0]} ${splitB[1]}`).getTime();

    if (timeA > timeB) {
      return 1;
    }

    if (timeA < timeB) {
      return -1;
    }

    if (timeA === timeB) {
      return 0;
    }
  });

  if (trackState.trackContent === "detailedInformation") {
    detailedTrackInformationData.value = hasLeft;
    return null;
  }

  // 分離出到診與完診
  const arrived = [];
  const endTime = [];

  arrive.forEach((doc) => {
    const alljudge = [];

    doc.followUpMedicalRecord.forEach((customer) => {
      const endTimeJudge = customer.detail.some((item) => item.cureContent.endTimeOfTreatment);

      if (endTimeJudge) {
        alljudge.push(customer);
      }
    });

    if (alljudge.length === 0) {
      arrived.push(doc);
    } else {
      endTime.push(doc);
    }
  });

  detailedTrackInformationData.value = [...arrived, ...endTime, ...hasLeft];
}

/** 切換醫美部或美容部 - 約診與已約診 */
const continuousOrReservedToggle = async () => {
  if (trackState.department === "AestheticMedicine") {
    resetSelectedDoctor();

    if (trackState.trackContent === "dateOfAppointment") await getDoctorFollowUpData();

    if (trackState.trackContent === "detailedInformation") await getDoctorFollowUpData();
  }

  if (trackState.department === "Beauty") {
    if (trackState.trackContent === "dateOfAppointment") await getDepartmentFollowUpData();

    if (trackState.trackContent === "detailedInformation") await getDepartmentFollowUpData();
  }

  getClinicPeriodLastTime();
};

export default {
  trackState,
  detailedinformationData,
  detailedTrackInformationData,
  getDoctors,
  getCurrentMonth,
  resetSelectedDoctor,
  showCalendar,
  getCalendar,
  timeSwitch,
  continuousOrReservedToggle,
  clinicPeriodToCh,
  // departmentToggle,
  getDaysOutpatientData,
  getClinicPeriodLastTime,
  getUpdateAppointmentData,
  searchDetailedInformation,
  getDoctorAttendanceData,
  detailedInformationInit
};
